/* ============================================================
   Özel Paketler — PDP cross-sell kombin kartı (Faz 1b + beden seçimi)
   Karta tıklanınca kombinin bileşen varyantlarını tek istekte sepete
   ekler (/cart/add.js çoklu items) ve cart drawer'ı (GoCart) açar.

   Beden seçimi (deneyimi aksatmadan):
   - Tek varyantlı (tek beden) bileşen otomatik seçilir.
   - PDP'de zaten seçili olan beden, o bileşen için otomatik seçilir.
   - Tüm bileşenlerin bedeni belliyse → modal AÇILMADAN direkt sepete eklenir
     (eski davranış; sıfır ek sürtünme).
   - Yalnız gerçekten seçilecek beden kalınca kompakt bir seçim modalı açılır.

   Bundle indirimi admin'deki native otomatik indirim / Bundles app
   tarafından uygulanır; tema sadece doğru varyantları sepete ekler.
   GoCart instance'ı theme.liquid'de window.goCart olarak expose edildi.
   ============================================================ */
(function () {
  'use strict';

  /* i18n: metinler theme.liquid'deki window.fosI18n adasından (locales/*.json)
     gelir; ada yoksa Türkçe fallback. __X__ yer tutucularını tt() doldurur. */
  var I18N = window.fosI18n || {};
  function tt(key, fallback, repl) {
    var s = (typeof I18N[key] === 'string' && I18N[key]) ? I18N[key] : fallback;
    if (repl) {
      for (var k in repl) { s = s.split('__' + k + '__').join(repl[k]); }
    }
    return s;
  }

  var DATA = null;
  function getData() {
    if (DATA !== null) {
      return DATA || null;
    }
    var el = document.getElementById('fos-combo-data');
    if (!el) {
      DATA = false;
      return null;
    }
    try {
      DATA = JSON.parse(el.textContent);
    } catch (e) {
      DATA = false;
    }
    return DATA || null;
  }

  function money(cents) {
    return Math.round(cents / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' TL';
  }

  function pdpSelectedVariantId() {
    var sel = document.querySelector('.size-options.selected-option');
    if (!sel) {
      return null;
    }
    var vid = parseInt(sel.getAttribute('data-id') || sel.getAttribute('data-variant-id'), 10);
    return vid || null;
  }

  /* Her bileşen için bilinen bedeni çöz; bilinmiyorsa variant=null. */
  function resolveSelections(data) {
    var pdpVid = pdpSelectedVariantId();
    return data.components.map(function (comp) {
      var chosen = null;
      if (comp.variants.length === 1) {
        chosen = comp.variants[0];
      } else if (pdpVid) {
        chosen = comp.variants.filter(function (v) { return v.id === pdpVid; })[0] || null;
      }
      return { comp: comp, variant: chosen };
    });
  }

  function refreshAndOpenCart(payload) {
    document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: payload }));
    if (window.goCart && typeof window.goCart.fetchAndOpenCart === 'function') {
      window.goCart.fetchAndOpenCart();
      return;
    }
    var trigger = document.querySelector('.js-go-cart-trigger');
    if (trigger) {
      trigger.click();
    }
  }

  function addItems(items, btn, onDone) {
    if (!items.length) {
      return;
    }
    if (btn) {
      btn.classList.remove('is-error');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    }
    window
      .fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (response) {
        return response.json().then(function (d) { return { ok: response.ok, data: d }; });
      })
      .then(function (result) {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
        if (!result.ok) {
          if (onDone) { onDone(false); }
          if (btn) {
            btn.classList.add('is-error');
            setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
          }
          return;
        }
        if (onDone) { onDone(true); }
        refreshAndOpenCart(result.data);
      })
      .catch(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
        }
        if (onDone) { onDone(false); }
      });
  }

  function selectionsToItems(sels) {
    return sels.map(function (s) { return { id: s.variant.id, quantity: 1 }; });
  }

  /* ----------------------------------------------------------
     Kompakt beden seçim modalı (body'ye eklenir → .cssanimation DIŞINDA).
     ---------------------------------------------------------- */
  var modal = null;
  var modalState = null;

  function buildModal() {
    if (modal) {
      return modal;
    }
    modal = document.createElement('div');
    modal.className = 'fos-csize';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="fos-csize__box" role="dialog" aria-modal="true" aria-label="' + tt('comboSizeDialog', 'Kombin beden seçimi') + '">' +
        '<div class="fos-csize__head">' +
          '<span class="fos-csize__titles">' +
            '<span class="fos-csize__kicker">' + tt('comboKicker', 'Kombini tamamla') + '</span>' +
            '<span class="fos-csize__title" data-csize-name></span>' +
          '</span>' +
          '<button type="button" class="fos-csize__close" aria-label="' + tt('close', 'Kapat') + '">&times;</button>' +
        '</div>' +
        '<div class="fos-csize__body" data-csize-body></div>' +
        '<div class="fos-csize__foot">' +
          '<span class="fos-csize__totals">' +
            '<span class="fos-csize__total" data-csize-total></span>' +
            '<span class="fos-csize__adv" data-csize-adv></span>' +
          '</span>' +
          '<button type="button" class="fos-csize__add" data-csize-add disabled>' + tt('comboAdd', 'Sepete ekle') + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.fos-csize__close')) {
        closeModal();
        return;
      }
      var sizeBtn = e.target.closest('.fos-csize__size');
      if (sizeBtn) {
        pickSize(parseInt(sizeBtn.getAttribute('data-idx'), 10), parseInt(sizeBtn.getAttribute('data-vid'), 10));
        return;
      }
      if (e.target.closest('[data-csize-add]')) {
        confirmAdd();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
    return modal;
  }

  function rowHtml(sel, idx) {
    var comp = sel.comp;
    var sizes;
    if (!comp.variants.length) {
      sizes = '<span class="fos-csize__soldout">' + tt('soldOut', 'Tükendi') + '</span>';
    } else if (comp.variants.length === 1) {
      sizes = '<span class="fos-csize__single">' + tt('oneSize', 'Tek beden') + '</span>';
    } else {
      sizes = '<span class="fos-csize__sizes">' + comp.variants.map(function (v) {
        var active = sel.variant && sel.variant.id === v.id ? ' is-active' : '';
        return '<button type="button" class="fos-csize__size' + active + '" data-idx="' + idx + '" data-vid="' + v.id + '">' +
          (v.size === 'Default Title' ? tt('oneSize', 'Tek beden') : v.size) + '</button>';
      }).join('') + '</span>';
    }
    var done = sel.variant ? ' is-done' : '';
    return '<div class="fos-csize__row' + done + '" data-row="' + idx + '">' +
      '<span class="fos-csize__thumb">' + (comp.image ? '<img src="' + comp.image + '" alt="" width="48" height="48">' : '') + '</span>' +
      '<span class="fos-csize__info">' +
        '<span class="fos-csize__name">' + comp.title + '</span>' +
        sizes +
      '</span>' +
      '<span class="fos-csize__check" aria-hidden="true"></span>' +
    '</div>';
  }

  function renderModal() {
    var data = modalState.data;
    modal.querySelector('[data-csize-name]').textContent = data.name || '';
    modal.querySelector('[data-csize-body]').innerHTML = modalState.sels.map(rowHtml).join('');
    updateModalFoot();
  }

  function updateModalFoot() {
    var sels = modalState.sels;
    var complete = sels.every(function (s) { return s.variant; });
    var anchor = 0;
    sels.forEach(function (s) { if (s.variant) { anchor += s.variant.price; } });
    var total = modalState.data.totalCents;
    var adv = anchor - total;

    modal.querySelector('[data-csize-total]').textContent = money(total);
    var advEl = modal.querySelector('[data-csize-adv]');
    if (complete && adv > 0) {
      advEl.textContent = tt('advantage', '__AMOUNT__ avantaj', { AMOUNT: money(adv) });
      advEl.style.display = '';
    } else {
      advEl.style.display = 'none';
    }
    var addBtn = modal.querySelector('[data-csize-add]');
    var addable = sels.every(function (s) { return s.comp.variants.length > 0; });
    addBtn.disabled = !(complete && addable);
  }

  function pickSize(idx, vid) {
    var sel = modalState.sels[idx];
    sel.variant = sel.comp.variants.filter(function (v) { return v.id === vid; })[0] || null;
    modalState.touched = true;
    // sadece ilgili satırı tazele
    var rowEl = modal.querySelector('[data-row="' + idx + '"]');
    if (rowEl) {
      rowEl.outerHTML = rowHtml(sel, idx);
    }
    updateModalFoot();
  }

  function openModal(data, sels, btn) {
    buildModal();
    modalState = { data: data, sels: sels, btn: btn, touched: false };
    renderModal();
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fos-csize-open');
  }

  /* Modalı yalnız kapat (sepete dokunmaz) — başarılı ekleme sonrası. */
  function hideModal() {
    if (!modal) {
      return;
    }
    if (modalState) {
      modalState.touched = false;
    }
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fos-csize-open');
  }

  /* Kullanıcı kombini tamamlamadan kapatırsa (X / dışına tıkla / Esc):
     bedeni belli olan bileşenler kaybolmasın — sepete ekle, küçük toast
     ile haber ver (drawer açılmaz; paket indirimi tamamlanınca oluşur). */
  function closeModal() {
    flushSelections();
    hideModal();
  }

  function flushSelections() {
    if (!modalState || !modalState.touched) {
      return;
    }
    modalState.touched = false; // çift ekleme koruması
    var items = modalState.sels
      .filter(function (s) { return s.variant; })
      .map(function (s) { return { id: s.variant.id, quantity: 1 }; });
    if (!items.length) {
      return;
    }
    window
      .fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (response) {
        return response.json().then(function (d) { return { ok: response.ok, data: d }; });
      })
      .then(function (result) {
        if (!result.ok) {
          toast(tt('partialAddFail', 'Sepete eklenemedi, tekrar deneyin.'), { error: true });
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: result.data }));
        if (window.goCart && typeof window.goCart.fetchCart === 'function') {
          try { window.goCart.fetchCart(); } catch (e) {}
        }
        toast(tt('partialAdded', '__N__ ürün sepete eklendi', { N: items.length }), {
          cta: tt('viewCart', 'Sepeti gör')
        });
      })
      .catch(function () {
        toast(tt('partialAddFail', 'Sepete eklenemedi, tekrar deneyin.'), { error: true });
      });
  }

  /* toast package-builder.js'te tanımlı (global, her sayfada yüklü). */
  function toast(message, opts) {
    if (typeof window.fosToast === 'function') {
      window.fosToast(message, opts);
    }
  }

  function confirmAdd() {
    var sels = modalState.sels;
    if (!sels.every(function (s) { return s.variant; })) {
      return;
    }
    var addBtn = modal.querySelector('[data-csize-add]');
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    addItems(selectionsToItems(sels), modalState.btn, function (ok) {
      addBtn.classList.remove('is-loading');
      if (ok) {
        hideModal(); // seçimler zaten eklendi → kapanışta tekrar akıtma
      } else {
        addBtn.disabled = false;
        addBtn.textContent = tt('retry', 'Tekrar dene');
      }
    });
  }

  /* ----------------------------------------------------------
     Kart tıklaması
     ---------------------------------------------------------- */
  function onComboClick(btn) {
    if (btn.classList.contains('is-loading')) {
      return;
    }
    var data = getData();
    if (!data || !data.components || !data.components.length) {
      // veri adası yoksa eski yola düş (data-variants ilk varyantlar)
      var raw = (btn.getAttribute('data-variants') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean)
        .map(function (id) { return { id: id, quantity: 1 }; });
      addItems(raw, btn);
      return;
    }

    var sels = resolveSelections(data);
    var allKnown = sels.every(function (s) { return s.variant; });
    var addable = sels.every(function (s) { return s.comp.variants.length > 0; });

    if (allKnown && addable) {
      addItems(selectionsToItems(sels), btn);
    } else {
      openModal(data, sels, btn);
    }
  }

  /* Event delegation: kart sonradan DOM'a girse de çalışır. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fos-combo]');
    if (!btn) {
      return;
    }
    e.preventDefault();
    onComboClick(btn);
  });

  /* ----------------------------------------------------------
     Slot-bazlı combo (Faz B): sabit ürün YOK, her slot kendi
     koleksiyonundan seçtirilir. Mevcut ürün kendi kategorisinin
     slotuna kilitli gelir (window.fosBuilder.currentProduct()).
     Builder-lite modalı açılır — gerçek çapa/avantaj orada,
     slotlar tam dolunca CANLI hesaplanır.
     ---------------------------------------------------------- */
  function onSlotsComboClick(btn) {
    if (btn.classList.contains('is-loading')) {
      return;
    }
    var data = getData();
    if (!data || data.mode !== 'slots' || !data.slots || !data.slots.length) {
      return;
    }
    if (!window.fosBuilder || typeof window.fosBuilder.open !== 'function') {
      return;
    }
    var cur = typeof window.fosBuilder.currentProduct === 'function' ? window.fosBuilder.currentProduct() : null;
    var slots = data.slots.map(function (s) {
      if (s.isCurrentSlot && cur) {
        return { collection: s.collectionHandle, locked: { product: cur.product, variant: cur.variant, inCart: false } };
      }
      return { collection: s.collectionHandle };
    });
    window.fosBuilder.open({
      totalCents: data.totalCents,
      packageHandle: data.handle,
      excludeTags: data.excludeTags || [],
      resumeFromCart: true,
      slots: slots
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fos-combo-slots]');
    if (!btn) {
      return;
    }
    e.preventDefault();
    onSlotsComboClick(btn);
  });

  /* Tarihli paket kartı (Kış İkilisi): bitiş anı geçince açık sekmede de
     kalkar — kasa o an kapanıyor, kart vaat ettiği fiyatı veremez. */
  var timed = document.querySelectorAll('[data-fos-ends]');
  if (timed.length) {
    var hideExpired = function () {
      var now = Date.now();
      timed.forEach(function (el) {
        if (parseInt(el.getAttribute('data-fos-ends'), 10) <= now) { el.style.display = 'none'; }
      });
    };
    hideExpired();
    setInterval(hideExpired, 15000);
  }
})();
